import { createModalStore } from '@/shared/lib/modal';

export const useBuyMinutesModalStore = createModalStore();
